export const fields = [
    // {field: 'TITLE', label: 'Название лида'},
    {field: 'NAME', label: 'Имя'},
    {field: 'LAST_NAME', label: 'Фамилия'},
    {field: 'SECOND_NAME', label: 'Отчество'},
    {field: 'COMPANY_TITLE', label: 'Компания'},
    {field: 'POST', label: 'Должность'},
    {field: 'EMAIL', label: 'E-mail', type: 'array'},
    {field: 'COMMENTS', label: 'Комментарий', type: 'textarea'}
];